import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('twofactor_authentication_setup'),
    title: defineMessage('add_another_email_address_to_fall_back_on'),
    description: defineMessage('for_using_the_authentic_ogging_into_approvalmax'),
    codeFieldTitle: defineMessage('alternative_email_address'),
    invalidEmailErrorText: defineMessage('this_email_address_is_not_valid'),
    emailPlaceholder: defineMessage('enter_an_alternative_email_address'),
    nextButton: defineMessage('send_me_the_code'),
};
